import router from '@/router';
import moment from 'moment';
// eslint-disable-next-line object-curly-newline
import { reactive, getCurrentInstance, watch, toRefs } from '@vue/composition-api';

export const isObject = (obj) => typeof obj === 'object' && obj !== null;

export const generateId = () => Math.floor(Math.random() * 10000);

export const isToday = (date) => {
  const today = new Date();
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  );
};

const getRandomFromArray = (array) => array[Math.floor(Math.random() * array.length)];

export const generateRandomNumberOrder = () => Math.floor(Math.random() * 10000);

// ? Light and Dark variant is not included
// prettier-ignore
export const getRandomBsVariant = () => getRandomFromArray(['primary', 'secondary', 'success', 'warning', 'danger', 'info']);

export const isDynamicRouteActive = (route) => {
  const { route: resolvedRoute } = router.resolve(route);
  return resolvedRoute.path === router.currentRoute.path;
};

// Thanks: https://medium.com/better-programming/reactive-vue-routes-with-the-composition-api-18c1abd878d1
export const useRouter = () => {
  const vm = getCurrentInstance().proxy;
  const state = reactive({
    route: vm.$route,
  });

  watch(
    () => vm.$route,
    (r) => {
      state.route = r;
    },
  );

  return { ...toRefs(state), router: vm.$router };
};

/**
 * This is just enhancement over Object.extend [Gives deep extend]
 * @param {target} a Object which contains values to be overridden
 * @param {source} b Object which contains values to override
 */
// export const objectExtend = (a, b) => {
//   // Don't touch 'null' or 'undefined' objects.
//   if (a == null || b == null) {
//     return a
//   }

//   Object.keys(b).forEach(key => {
//     if (Object.prototype.toString.call(b[key]) === '[object Object]') {
//       if (Object.prototype.toString.call(a[key]) !== '[object Object]') {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = b[key]
//       } else {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = objectExtend(a[key], b[key])
//       }
//     } else {
//       // eslint-disable-next-line no-param-reassign
//       a[key] = b[key]
//     }
//   })

//   return a
// }

export const resolverColorById = (id) => {
  switch (id) {
    case 1:
      return 'primary';
    case 2:
      return 'secondary';
    case 3:
      return 'success';
    case 4:
      return 'danger';
    case 5:
      return 'warning';
    case 6:
      return 'info';
    default:
      return 'primary';
  }
};

export const segundosAteTerminoPromocao = (dataTermino, horaTermino) => {
  // Converter data e hora de término para um objeto Moment.js
  const dataHoraTermino = moment(`${dataTermino} ${horaTermino}`, 'YYYY-MM-DD HH:mm');

  // Obter a data e hora atuais como um objeto Moment.js
  const agora = moment();

  // Calcular a diferença em segundos entre a data/hora de término e agora
  const segundosAteTermino = dataHoraTermino.diff(agora, 'seconds');

  return segundosAteTermino > 0 ? segundosAteTermino : 0;
};
export const temporizadorPromocao = (segundosAteTermino) => {
  if (segundosAteTermino > 0) {
    var timer = setInterval(() => {
      segundosAteTermino--;
      if (segundosAteTermino <= 0) {
        clearInterval(timer);
        console.log('A promoção terminou!');
      } else {
        console.log('Tempo restante:', segundosParaTempo(segundosAteTermino));
      }
    }, 1000);
  } else {
    console.log('A promoção já terminou!');
  }
};

export const segundosParaTempo = (segundos) => {
  const duracao = moment.duration(segundos, 'seconds');
  const horas = duracao.hours();
  const minutos = duracao.minutes();
  const segundosRestantes = duracao.seconds();
  return `${horas}h ${minutos}m ${segundosRestantes}s`;
};
